import axios from "axios";
import store from "@/store";
import router from "@/router";

const requestWreathOrderHistory = payload => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/cal/wreath/order-history?target=${
      payload.target
    }&startDate=${payload.startDate}&endDate=${
      payload.endDate
    }&searchTxt=${encodeURIComponent(payload.searchTxt)}&page=${payload.page}&type=${payload.type}`
  );
};

const requestAllWreathOrderHistory = payload => {
  return axios.get(
    `${
      process.env.VUE_APP_APIURL
    }/api/app/cal/wreath/order-history/all?target=${payload.target}&startDate=${
      payload.startDate
    }&endDate=${payload.endDate}&searchTxt=${encodeURIComponent(
      payload.searchTxt
    )}&page=${payload.page}`
  );
};

const requestCompanyWreathOrderHistory = payload => {
  console.log(payload)
  if(payload.type === "funeral" || payload.type === undefined) {
    return axios.get(
      `${process.env.VUE_APP_APIURL}/api/app/cal/company/order-history?TVM_GRP=${
        payload.TVM_GRP
      }&target=${payload.target}&startDate=${payload.startDate}&endDate=${
        payload.endDate
      }&searchTxt=${encodeURIComponent(payload.searchTxt)}&page=${payload.page}&type=funeral`
    );
  } else {
    return axios.get(
      `${process.env.VUE_APP_APIURL}/api/app/cal/company/order-history?TVM_GRP=&target=${
        payload.target
      }&startDate=${payload.startDate}&endDate=${payload.endDate}&searchTxt=${
      encodeURIComponent(payload.searchTxt)}&page=${payload.page}&type=${
        payload.type
      }&id=${payload.id}`
    );
  }
};

export {
  requestWreathOrderHistory,
  requestCompanyWreathOrderHistory,
  requestAllWreathOrderHistory
};
